module.exports = __webpack_public_path__ + "img/okcupid.8a3d6ac.svg";